import { THeaderResponse } from '@monorepo/types';
import { Action } from '@ngrx/store/src/models';

export class InitializeHeader implements Action {
  readonly type = 'INITIALIZE_HEADER' as const;
  constructor(public payload: { headerResponse: THeaderResponse; subjectKey: string }) {}
}

export class InitializeShift implements Action {
  readonly type = 'INITIALIZE_SHIFT' as const;
  constructor(public payload: THeaderResponse['shifts']) {}
}

export class HeaderLoaded implements Action {
  readonly type = 'HEADER_LOADED' as const;
  constructor() {}
}

export class HeaderTabChange implements Action {
  readonly type = 'HEADER_TAB_CHANGE' as const;
  constructor(public payload: { activeTab: THeaderResponse['activeTab'] }) {}
}

export class ToggleMobileNav implements Action {
  readonly type = 'TOGGLE_MOBILE_NAV' as const;
  constructor() {}
}

export type THeaderActions = InitializeHeader | InitializeShift | HeaderLoaded | HeaderTabChange | ToggleMobileNav;
